import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';

/** The CEO view only for users the API gives executive access; everyone else lands on their home page. */
export const executiveGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(AuthService);
  return auth
    .resolveExecutiveAccess()
    .pipe(map((allowed) => allowed || router.createUrlTree([auth.getLandingRoute()])));
};
